module.exports = __webpack_public_path__ + "img/logo.5ed2dd34.png";